<template>
  <div class="backstage__buttons __wrapper">
    <button
      class="backstage__buttons __button --grid md:hidden"
      @click="$store.state.activeModelDetailSlide = false"
    >
      <aha-icon
        name="grid-4-dots"
        viewBox="0 0 24 24"
        width="14"
        height="14"
        class="text-base-0 mb-0.5"
      />
    </button>
    <button
      class="backstage__buttons __button"
      @click="$emit('selectPrevSlide', 'icon-arrow-left')"
      :class="{'opacity-0 pointer-events-none': !hasPrevSlide}"
    >
      <aha-icon
        name="arrow-no-tail"
        width="12"
        height="18"
        viewBox="0 0 8 14"
        class="backstage__buttons __icon"
      />
    </button>
    <button
      class="backstage__buttons __button"
      @click="$emit('selectNextSlide', 'icon-arrow-right')"
      :class="{'opacity-0 pointer-events-none': !hasNextSlide}"
    >
      <aha-icon
        name="arrow-no-tail"
        width="12"
        height="18"
        viewBox="0 0 8 14"
        class="text-base-0 mb-0.5"
      />
    </button>
  </div>
</template>

<script>
export default {
  computed: {
    hasPrevSlide() {
      return this.$store.getters.currentSlideIndex > 0
    },
    hasNextSlide() {
      return (
        this.$store.getters.currentSlideIndex <
        this.$store.state.presentation.slides.length - 1
      )
    },
  },
}
</script>

<style lang="scss" scoped>
.backstage__buttons {
  &.__wrapper {
    @apply flex justify-center w-full px-6;
    @apply gap-2 md:gap-0 md:justify-between md:absolute md:top-1/4 lg:top-1/3;
    @apply pt-4 md:pt-0;
  }
  &.__button {
    background-color: #3F4557;
    padding: 7px 11px;
    border-radius: 99px;
    box-shadow: 0px 6.54765px 11.4584px rgba(82, 95, 127, 0.13);
  }
  &.--grid {
    position: absolute;
    left: 4rem;
  }
  &.__icon {
    transform: rotate(180deg);
    color: #ffffff;
    margin-bottom: 0.125rem;
  }
}
</style>
